export default __webpack_public_path__ + "static/media/notification_announcement_icon.9992b031.svg";